import { UserAuthWrapper } from 'redux-auth-wrapper';
import { loadingMeSelector } from 'common/permissions/selectors';
import { viewStudyTeamMemberPredicate, viewStudyMetadataPredicate, viewStudySettingsPredicate, viewStudyMonitorsPredicate, viewStudyTeamPredicate } from 'common/permissions/studyPredicates';
import { homeRouteSelector } from 'common/features/selectors';

export const ForUsersWithViewStudyMetadataAccess = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: viewStudyMetadataPredicate,
    failureRedirectPath: (state) => homeRouteSelector(state)
});

export const ForUsersWithViewUsersPermission = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: viewStudyTeamMemberPredicate,
    failureRedirectPath: (state) => homeRouteSelector(state)
});

export const ForUsersWithViewStudyMonitorsPermission = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: viewStudyMonitorsPredicate,
    failureRedirectPath: (state) => homeRouteSelector(state)
});

export const ForUsersWithViewStudyTeamPermission = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: viewStudyTeamPredicate,
    failureRedirectPath: (state) => homeRouteSelector(state)
});


export const ForUsersWithViewStudySettingsAccess = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: viewStudySettingsPredicate,
    failureRedirectPath: (state) => homeRouteSelector(state)
});